var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#97d9b1;}.d{fill:#88d3a6;}.e{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 50,
    cy: 50,
    r: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0097e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.66,
    y1: 33.71,
    x2: 95.21,
    y2: 33.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#74d000"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50,99A49,49,0,1,1,99,50,49.05,49.05,0,0,1,50,99Zm0-76.51A27.51,27.51,0,1,0,77.51,50,27.54,27.54,0,0,0,50,22.49Z",
    transform: "translate(-1 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.87,2.66C80,14.47,42.71,2.66,40.66,55.87,86.19,87.84,99.9,24.85,93.87,2.66Z",
    transform: "translate(-1 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.48,30.57l.22-.27a65.42,65.42,0,0,0,8.85,5.75,47.12,47.12,0,0,0,4.77,2.25c.83.3,1.64.63,2.49.86l.63.19.32.09.24.06.2,0,1.33.49-1.46-.16-.35-.09-1.26-.37c-.84-.26-1.67-.56-2.48-.88a45.49,45.49,0,0,1-4.73-2.25A65.65,65.65,0,0,1,65.48,30.57Z",
    transform: "translate(-1 -1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M84.08,16.25A96.28,96.28,0,0,1,76,23c-5.93,4.09-11.61,7.36-11.59,7.38a63.78,63.78,0,0,0-6.78,4.15,63.54,63.54,0,0,0-4.53,4.63,47,47,0,0,0-5.21,7.95c-.45.85-.95,2.38-1.11,2.74-.58,1.33-1.52,2.14-1.55,3.37.61-1.07,1.62-1.51,2.4-3A45.75,45.75,0,0,1,58,36.11a50.88,50.88,0,0,1,7-4.95s5.49-3.58,11.45-7.68c3-2.06,6.82-6.08,8.68-7.68a25.58,25.58,0,0,0,3.59-4.14A37.14,37.14,0,0,1,84.08,16.25Z",
    transform: "translate(-1 -1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.74,39.6l-.35,0a37.43,37.43,0,0,1-.19-5.29c0-.89.1-1.77.21-2.65,0-.44.12-.87.18-1.31l.15-.83c.15-.45.34-.89.51-1.33-.06.49-.14,1-.17,1.45l0,.26c0,.21-.08.42-.11.63-.07.43-.13.86-.18,1.28-.1.86-.15,1.72-.19,2.58A37.13,37.13,0,0,0,52.74,39.6Z",
    transform: "translate(-1 -1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.05,43.25l.21-.29a73.22,73.22,0,0,0,9.14,5.72,52.7,52.7,0,0,0,4.9,2.24c.84.31,1.68.64,2.55.87l.64.19.32.09.26.07.19,0,1.34.49-1.46-.16-.36-.08-1.29-.37c-.86-.27-1.7-.57-2.53-.9a49.57,49.57,0,0,1-4.85-2.24A73.11,73.11,0,0,1,51.05,43.25Z",
    transform: "translate(-1 -1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M72.14,25.92l-.35,0a40.7,40.7,0,0,1-.16-5.41c0-.9.09-1.8.19-2.7.05-.45.12-.9.19-1.34l.15-.84c.14-.46.33-.9.49-1.34-.05.49-.13,1-.16,1.45l0,.26c0,.22-.08.43-.11.65-.06.44-.13.87-.17,1.31-.1.88-.15,1.76-.18,2.64A40.45,40.45,0,0,0,72.14,25.92Z",
    transform: "translate(-1 -1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M84.08,16.25C82.65,17.51,78.14,21,75.18,23c-5.93,4.09-11.61,7.36-11.59,7.38a63.78,63.78,0,0,0-6.78,4.15,61.4,61.4,0,0,0-4.53,4.63,47,47,0,0,0-5.21,7.95c-.45.85-1,2.38-1.11,2.74a7.82,7.82,0,0,0-.73,3.42c.6-1.07.79-1.56,1.58-3A45.56,45.56,0,0,1,57.14,36.11a51.07,51.07,0,0,1,7-4.95s5.49-3.58,11.45-7.68c3-2.06,7.67-6.08,9.53-7.68a25.58,25.58,0,0,0,3.59-4.14A37.14,37.14,0,0,1,84.08,16.25Z",
    transform: "translate(-1 -1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M50.7,43.21l.22-.28a66,66,0,0,0,8.84,5.76,50.62,50.62,0,0,0,4.78,2.24c.83.3,1.64.64,2.49.87l.63.18.32.09.24.07.2,0,1.33.49-1.46-.16-.35-.08-1.26-.37c-.84-.27-1.67-.56-2.48-.89a47.55,47.55,0,0,1-4.73-2.24A67.67,67.67,0,0,1,50.7,43.21Z",
    transform: "translate(-1 -1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65,30.57l.22-.27a66.69,66.69,0,0,0,8.85,5.75,48.32,48.32,0,0,0,4.78,2.25c.83.3,1.64.63,2.49.86l.63.19.32.09a1.48,1.48,0,0,0,.24.06l.2,0,1.33.49-1.46-.16-.35-.09L81,39.42c-.83-.26-1.66-.56-2.47-.88a45.49,45.49,0,0,1-4.73-2.25A65.75,65.75,0,0,1,65,30.57Z",
    transform: "translate(-1 -1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M52.42,39.58l-.35,0a42.74,42.74,0,0,1,0-5.88,29.28,29.28,0,0,1,.3-2.94c.07-.48.16-1,.26-1.45,0-.23.12-.51.16-.68l0-.2c.17-.45.4-.87.59-1.3-.09.48-.21.95-.26,1.43l-.07.27c-.06.23-.11.46-.15.7-.1.46-.19.93-.25,1.41-.14,1-.24,1.9-.29,2.86A42.44,42.44,0,0,0,52.42,39.58Z",
    transform: "translate(-1 -1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M71.8,26.1l-.36,0a42.9,42.9,0,0,1,0-5.89c.06-1,.15-2,.3-2.93.07-.49.17-1,.26-1.46,0-.22.13-.51.16-.68l0-.2c.17-.45.4-.87.59-1.3-.09.48-.2,1-.26,1.43l-.06.27c-.06.23-.12.46-.16.7-.1.47-.18.94-.25,1.41-.14,1-.23,1.9-.29,2.86A40.84,40.84,0,0,0,71.8,26.1Z",
    transform: "translate(-1 -1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff29d9b69d8b273f2a9fb3f20dfa1c66.svg";
export { ForwardRef as ReactComponent };